import React from "react";
import { Link } from "react-router-dom";
import Navbar from './Navbar';

const PolizaInpaga = () => {
    return (
        <div className="container-poli-inp">
        <Navbar></Navbar> 
        <h1 className="text-poli-inp text-white">Ups! tu Póliza está impaga </h1>
       
         <button className="btn-poli-inp form-control mt-4"  data-bs-toggle="modal" data-bs-target="#staticBackdrop">Paga aquí tu Póliza</button>
      

        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div className="modal-dialog bg-white">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title text-white" id="staticBackdropLabel">Pago al día</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <p className="text-white">Has realizado con éxito el pago, ahora puedes continuar con el ingreso del siniestro.</p>
      </div>
      <div className="modal-footer">
      <Link to="/EntrySinister">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </Link>
      </div>
    </div>
  </div>
</div>
  </div>


    )
}

export default PolizaInpaga